<template>
    <div>
        <v-card color="#EDF1F3">
        <v-layout align-center justify-start style="padding-left: 20px">
          <v-flex xs3>
            <div class="headline">
              {{ $t("settings.termsAndConditions.date") }}
              {{this.term.created_at ? moment(this.term.created_at).format(" DD MMM YYYY HH:mm") : $t('settings.termsAndConditions.noData')}}
            </div>
            <div style="color: #8599a3">
                    <b
                      ><a href="#" @click="openDoc(term.file_url)"
                        >{{ $t("settings.termsAndConditions.openFile") }}</a
                      ></b
                    >
            </div>
                
          </v-flex>
          <v-flex xs8> </v-flex>
        </v-layout>
      </v-card>
      <v-btn color="primary" dark class="mb-2 hbtn" to="/terms_and_conditions/create"
        >{{ $t("settings.termsAndConditions.new") }}</v-btn
      >
      <v-data-table :headers="headers" :items="responses" :loading="loading">
                  <template v-slot:items="props">
                    <tr :class="[props.item.response == 'ACCEPT' ? 'accept' : 'reject']">
                      <td class="text-xs-left">{{ props.item.username }}</td>
                      <td class="text-xs-left">{{ `${props.item.first_name} ${props.item.last_name}` }}</td>
                      <td class="text-xs-left">{{ !props.item.response ? 'NO_RESPONSE' :  props.item.response}}</td>
                      <td class="text-xs-left">{{ moment(props.item.created_at).format("DD-MM-YYYY HH:mm:ss") }}</td>
                    </tr>
                  </template>
        </v-data-table>
    </div>
  </template>
  
  <style lang="scss">
  .hbtn {
    float: right;
    z-index: 1;
    margin-top: 20px;
    margin-right: 20px;
    padding: 0px 45px;
  }
  .open {
  margin-bottom: 15px;
  margin-left: 35px;
}
.reject {
  td {
      background-color: rgba(220, 39, 39, 0.08);
      border-radius: 4px;
      color: rgb(220, 39, 39);
  }
}
  .accept {
  td {
      background-color: rgba(99, 228, 24, 0.08);
      border-radius: 4px;
      color: rgb(5, 116, 51);
  }
}
  </style>
  
  <script>
  import DataTable from "@/components/monaco/DataTable";
  import moment from "moment";
  
  export default {
    name: "TermsAndConditions",
    title() {
      return this.$t("settings.termsAndConditions.title");
    },
    components: { DataTable },
    data() {
      return {
        responses: [],
        term: {},
        loading: true,
      };
    },
  
    computed: {
      headers() {
        return [
            { text: this.$t('settings.termsAndConditions.captainUsername'), value:'captain_id' },
            { text: this.$t('settings.termsAndConditions.captainName'), value:'captain_id' },
            { text: this.$t('settings.termsAndConditions.answer'), value:'response' },
            { text: this.$t('settings.termsAndConditions.answeredAt'), value:'created_at' },
          ];
      },
    },
    methods: {
        openDoc(value) {
      window.open(this.api.GET_TERM(value), "_blank");
    },
    },
    mounted() {
        this.axios.get(this.api.ACTIONS.TERMS).then(({ data }) => {
      this.term = data.data;
      this.responses = data.data.responses;
      console.log('data');
      console.log(data);
    }).then(()=>{ this.loading = false;}).catch((err) => {
          console.log(err.message);
          this.loading = false;
        });
    },
  };
  </script>
  